
























































































import { Component, Vue } from "vue-property-decorator";
import CategoriesApi from "@/services/CategoriesApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import UsersApi from "@/services/UsersApi";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import { Category, MaterialGroup, MaterialGroupList, SortDirection } from "@/api/lab-base-api-client";
import AuthModule from "@/store/auth";

@Component
export default class CMaterialGroups extends Vue {
  // breadcrumbs設定
  private breadcrumbs = [
    {
      text: "category",
      disabled: false,
      to: { name: this.$route.name === "UContents" ? "UCategory" : "OCategory" },
      exact: true,
    },
    {
      text: this.$route.params.category,
      disabled: true,
    },
  ];

  private category: Category | null = null;

  // materialGroup一覧
  private materialGroups: MaterialGroupList[] = [];

  // 終了教材の表示
  private compMaterialGroupUuids: string[] = [];

  // 表示するmaterialGroup一覧
  private showMaterialGroups: MaterialGroupList[] = [];

  // paginationのactiveページ
  private page = 1;

  // 1ページに表示する数
  private pageSize = 5;

  // paginationのlength
  private pageLength = this.materialGroups.length / this.pageSize;

  // materialGroupの総数
  private total = this.materialGroups.length;

  // 表示しているMaterialGroupのindex
  private showMaterialGroupsIndex = 0;

  private padNum = String(this.showMaterialGroupsIndex).padStart(1, "0");

  // プレミアム登録ダイアログ
  private isPremierDialog = false;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // ユーザー以外、または有料ユーザーかつ有料コンテンツ、または無料コンテンツ
  private isAllowAccess(materialGroup: MaterialGroup) {
    return (
      AuthModule.me?.role.id !== (2 || 4) ||
      (AuthModule.me?.paidFlag && materialGroup?.planId) ||
      !materialGroup?.planId
    );
  }

  // ページ読み込み時に実行
  private async mounted() {
    await Promise.all([this.fetch(), this.checkOrganizationExpiration()]);

    this.setList();
    this.setPaginationLength();
  }

  // organizationUser契約期限のチェック
  private async checkOrganizationExpiration() {
    if (!this.me || this.me.roleId !== 4) {
      return;
    }
    await OrganizationUsersApi.instance.checkExpirationDate(this.me.uuid);
  }

  // materialGroup一覧の取得
  private async fetch() {
    if (!this.me) {
      return;
    }

    const categoriesRes = await CategoriesApi.instance.getCategoryById(Number(this.$route.query.id));
    if (categoriesRes.data.data?.category) {
      this.category = categoriesRes.data.data?.category;
    }

    // MaterialGroup一覧取得
    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup(
      undefined,
      undefined,
      SortDirection.Asc,
      undefined,
      undefined,
      true
    );
    // カテゴリーが存在するMaterialGroup一覧に
    const materialGroups = materialGroupsRes.data.data.items.filter(
      (materialGroup: { categories: {} }) => materialGroup.categories
    );

    // カテゴリーと一致し、かつmaterialを持つMaterialGroupを取り出す
    materialGroups.forEach((materialGroup: MaterialGroupList) => {
      // カテゴリ-の数分回す
      for (let i = 0; i < materialGroup.categories.length; i += 1) {
        if (!materialGroup.materials) {
          return;
        }
        // カテゴリーidとqueryのidが同一かつmaterialsが一つ以上、かつ非公開教材でない場合
        if (
          materialGroup.categories[i].id === Number(this.$route.query.id) &&
          !materialGroup.visibilityFlag &&
          materialGroup.materials.length > 0
        ) {
          const materials = materialGroup.materials.filter((material: { deleted: boolean }) => !material.deleted);
          // eslint-disable-next-line no-param-reassign
          materialGroup.materials = materials;
          this.materialGroups.push(materialGroup);
        }
      }
    });

    // ユーザの場合、終了した教材一覧（MaterialGroups）の取得、完了した教材のuuid一覧を取得代入
    if (this.me.role.id === 2 || this.me.role.id === 4) {
      // TODO:団体所属ユーザーにはuserDetailUuidがない？完了した教材が取得できない
      const userDetailMaterialGroups = await UsersApi.instance.getCompleteMaterialGroupByUserDetailUuid(
        this.me?.userDetailUuid
      );
      if (userDetailMaterialGroups.data.data.completeMaterialGroup) {
        this.compMaterialGroupUuids = userDetailMaterialGroups.data.data.completeMaterialGroup.items.map(
          (item: { materialGroupUuid: string }) => {
            return item.materialGroupUuid;
          }
        );
      }
    }
  }

  // 表示するmaterialGroup一覧をセット
  private setList() {
    // コンテンツ番号
    if (this.$route.query.page) {
      this.showMaterialGroupsIndex = 5 * (Number(this.$route.query.page) - 1);
    }
    // paginationのactiveを、query.pageがあればその数、なければ1に
    this.page = Number(this.$route.query.page) || 1;

    // materialGroup一覧から表示させるmaterialGroupを切り抜き、showMaterialGroupsに代入
    this.showMaterialGroups = this.materialGroups.slice(this.pageSize * (this.page - 1), this.pageSize * this.page);
  }

  // 始めるをクリック
  private clickMaterialGroup(materialGroup: MaterialGroupList) {
    if (!materialGroup.materials) {
      return;
    }
    materialGroup.materials.sort((a, b) => {
      if (a.sort > b.sort) {
        return 1;
      }
      return -1;
    });

    this.$router.push({
      name: this.$route.name === "UContents" ? "UContent" : "OContent",
      params: { content: materialGroup.name },
      query: { uuid: materialGroup.uuid, material: materialGroup.materials[0].uuid },
    });
  }

  /**
   * 完了している教材か判別
   */
  private checkCompleted(materialGroup: MaterialGroupList) {
    return this.compMaterialGroupUuids.includes(materialGroup.uuid);
  }

  // pagination変更時に実行
  private pageChange(pageNumber: number) {
    // paginationの番号をqueryに渡す
    this.$router.push({ name: "UContents", query: { id: this.$route.query.id, page: String(pageNumber) } });
    // materialGroup一覧から表示させるmaterialGroupを切り抜き、showMaterialGroupsに代入
    this.showMaterialGroups = this.materialGroups.slice(this.pageSize * (pageNumber - 1), this.pageSize * pageNumber);
    this.setList();
  }

  // paginationの表示設定
  setPaginationLength() {
    this.total = this.materialGroups.length;
    if (this.total < this.pageSize) {
      this.pageLength = 1;
    } else if (this.total % this.pageSize === 0) {
      this.pageLength = this.total / this.pageSize;
    } else {
      this.pageLength = Math.floor(this.total / this.pageSize) + 1;
    }
  }
}
